import { AllReportsScreen } from '@felix/ui';
import { useTranslation } from 'react-i18next';
import { Shell } from '../components/Shell.js';
import { officeVoyageSource } from '../voyage-source.js';

/**
 * Voyage ▸ Reports ▸ All Reports ve rapor öğeleri (ortak ekran; ADR 0082). Ofiste salt okunur:
 * raporlar gemide girilir; gemi süzgeçte seçilir.
 */
export function AllReportsPage() {
  const { t } = useTranslation();
  return (
    <Shell title={t('voyage.allReports.title')}>
      <AllReportsScreen source={officeVoyageSource} />
    </Shell>
  );
}
